import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { PAGE_METADATA } from '../data/scrapeData';

export default function SEOHead({ title, description }) {
  const location = useLocation();
  const path = location.pathname;
  
  const defaultMeta = PAGE_METADATA[path] || PAGE_METADATA[path + '/'] || {
    title: "Vognmand & Entreprenør DBM aps",
    description: "Vognmand & Entreprenør DBM Aps - Din lokale Vognmand & Entreprenør i Hjorthede ved Bjerringbro."
  };

  const finalTitle = title || defaultMeta.title;
  const finalDesc = description || defaultMeta.description;

  return (
    <Helmet>
      <title>{finalTitle}</title>
      {finalDesc && <meta name="description" content={finalDesc} />}
      <meta property="og:title" content={finalTitle} />
      {finalDesc && <meta property="og:description" content={finalDesc} />}
      <meta property="og:type" content="website" />
    </Helmet>
  );
}
